export default __webpack_public_path__ + "static/media/add-fav-white.da9b5c68.svg";